/**
 * Cookie names used for authentication tokens.
 * This file is kept separate from token-manager.ts to avoid importing axios
 * in Edge Runtime contexts (e.g., middleware).
 *
 * Each property includes a description and uses value as type for better type safety.
 */

import { isStaging } from '@/libs/getEnvironment';

const PREFIX = isStaging() ? `${process.env.NEXT_PUBLIC_ENVIRONMENT}_` : '';

export const AUTH_COOKIE_NAMES = {
  /** Access token cookie */
  accessToken: `${PREFIX}auth_access_token`,
  /** Refresh token cookie */
  refreshToken: `${PREFIX}auth_refresh_token`,
  /** Token expiry cookie */
  tokenExpiry: `${PREFIX}auth_token_expiry`,
  /** Security token cookie */
  securityToken: `${PREFIX}security_token`,
} as const;

export type AuthCookieName = typeof AUTH_COOKIE_NAMES[keyof typeof AUTH_COOKIE_NAMES];
